<template>
  <div class="flexible">
    <v-card
      v-for="e in evaluations"
      :key="e.id"
      class="card-a-puce"
    >
      <v-card-title
        primary-title
        class="headline font-weight-bold eval-title"
      >
        <slot :evaluation="e" />
      </v-card-title>
      <readonly-field
        v-for="f in e.fields"
        :key="f.id"
        :field="f"
      />
      <v-card-actions
        layout="row"
        layout-align="end end"
      >
        <span v-if="e.updated_at">Updated on {{ formatDateHuman(e.updated_at) }}</span>
        <span v-else>Created on {{ formatDateHuman(e.created_at) }}</span>
        <v-btn
          flat
          color="primary"
          @click="$emit('edit', e)"
        >
          <v-icon
            right
            color="primary"
          >
            mdi-pencil
          </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  import DateMixin from '@/mixins/date'
  import ReadonlyField from './GenericForm/ReadonlyField'

  export default {
    components: {ReadonlyField},
    mixins: [DateMixin],
    props: {
      evaluations: {
        type: Array,
        required: true
      }
    }
  }
</script>
<style scoped lang="sass">
  .flexible
    display: flex
    flex-direction: row
    flex-wrap: wrap

    .card-a-puce
      margin: 5px 10px
      min-width: 400px

  .eval-title
    display: flex
    flex-direction: row
    justify-content: space-between
    align-items: center

    .name
      display: flex
      align-items: center

  .exceeded
    color: tomato

  .clock
    display: flex
    align-items: center
</style>
